var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMobile)?_c('rb-panel',{attrs:{"visible":_vm.afterpayIsVisible},on:{"closed":_vm.closeAfterpay}},[_c('rb-afterpay-panel')],1):_c('rb-afterpay-modal',{attrs:{"afterpay-is-visible":_vm.afterpayIsVisible},on:{"closed":_vm.closeAfterpay}})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }